import React, {Component} from 'react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';
import {colors} from '../../../../common/constants/colors';

class LineChartInCpd extends Component {
  render() {
    const {data, handleDrillDownByUser} = this.props;
    return (
      <ResponsiveContainer width='100%' height={500}>
        <LineChart data={data}
          margin={{'top': 15, 'right': 25, 'left': 0, 'bottom': 5}}>
          <XAxis dataKey='label' />
          <YAxis />
          <CartesianGrid strokeDasharray='3 3' />
          <Tooltip />
          <Legend />
          <Line type='monotone' dataKey='value' stroke={colors[0]} name='Total Líneas'
            activeDot={{'onClick': ({'payload': {label}}) => handleDrillDownByUser(label), 'r': 6}}
          />;

        </LineChart>
      </ResponsiveContainer>
    );
  }
}

export default LineChartInCpd;
